import copyDefault from "../constants/copyDefault";
import copyDefaultDemo from "../constants/copyDefault.demo";
import { type ConfigResponse, getConfig as getRealConfig } from "../api/config";
import merge from "lodash/merge";
import { isDemoMode } from "../stores/mode";

export async function getConfig(domain: string): Promise<ConfigResponse> {
  const config =  domain.startsWith("localhost:")
    ? { config: merge(copyDefault, copyDefaultDemo) }
    : await getRealConfig(domain, { skipAllErrorHandling: true });

  if (isDemoMode()) {
    // assure that the config includes demo menus even if the real api was used
    (config.config as typeof copyDefaultDemo).menus = copyDefaultDemo.menus;
  }
  return config;
}
